<template>
  <b-container> 
    <b-row class="mt-3">  
      <b-col> 
        <b-card-group deck> 
          <b-card bg-variant="Light"  header="Cliente" class="text-center">
            <b-card-text>
              <ul class="client_details">
                <li><i class="fas fa-user"></i> {{items.firstname}} {{items.lastname}}</li>
                <li><i class="far fa-envelope"></i> {{items.email}}</li>
                <li><i class="fas fa-phone-alt"></i> {{items.phoneNumber}} </li> 
              </ul>
            </b-card-text>
          </b-card> 
          <b-card bg-variant="Light" header="No. Servicios" class="text-center">
            <b-card-text>
              <div style="font-size:45px;" v-if="items.servicesNumbers">{{items.servicesNumbers.length}}</div>
              <div style="font-size:45px;" v-if="items.servicesNumbers == null">0</div>
            </b-card-text>
          </b-card> 
          <b-card bg-variant="Light"   header="Cotizaciones" class="text-center">
            <b-card-text>
              <div style="font-size:45px;" v-if="quotes">{{quotes.length}}</div>
              <div style="font-size:45px;" v-if="quotes == null">0</div> 
               
            </b-card-text>
          </b-card>
         
    </b-card-group>
     </b-col>
    </b-row>
    <div class="my-3 p-3 bg-white rounded shadow-sm"> 
      <h4 class="border-bottom border-gray pb-2 mb-0">No. servicios del cliente: {{ cliente }}</h4>
      <div class="media text-muted pt-3">  
          <b-table
            show-empty
            small
            stacked="md"
            :items="items.servicesNumbers"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"  
          >
          <template v-slot:cell(name)="row">
              {{ row.value.first }} {{ row.value.last }}
          </template>
            <template v-slot:cell(contact)="row">
                <ul>
                    <li><i class="fas fa-user"></i> {{ row.item.contact.name }}</li>
                    <li><i class="fas fa-phone-alt"></i> {{ row.item.contact.phoneNumber }}</li>
                    <li><i class="far fa-envelope"></i> {{ row.item.contact.email }}</li>
                </ul> 
          </template>
          <template v-slot:cell(created)="row">
              {{ row.item.created | formatDate }} 
          </template> 
          </b-table>  
      </div>
      <b-container>
        <b-row class="justify-content-end">
          <b-col sm="6">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </div> 
    <div class="my-3 p-3 bg-white rounded shadow-sm">  
      <h4 class="border-bottom border-gray pb-2 mb-0">Cotizaciones del cliente: {{ cliente }}</h4>  
      <div class="media text-muted pt-3">   
          <b-table
            show-empty
            small
            stacked="md"
            :items="quotes"
            :fields="fields2"
            :current-page="currentPage2"
            :per-page="perPage2"  
          >
            <template v-slot:cell(data.porcentaje_cobertura)="row">
                    {{ row.item.data.porcentaje_cobertura }} %
                </template>
                <template v-slot:cell(createdAt)="row">
                    {{ row.item.createdAt | formatDate }} 
                </template>
                 <template v-slot:cell(actions)="row">  
    

                    <b-button  size="sm" @click="view(row.item._id)" class="mr-1 btn_editar">
                        <i class="far fa-edit"></i>
                    </b-button>
                    <b-button  size="sm" @click="openPDF(row.item._id)" class="mr-1 btn_editar">
                        <i class="far fa-eye"></i>
                    </b-button>
                    <b-button v-if=" esAdministrador()" id="show-btn" @click="modalDeletef(row.item._id)" class="mr-1 btn_editar">
                        <i class="far fa-trash-alt"></i>
                    </b-button>
                </template>
                <template v-slot:cell(public)="row"> 
                  <b-form-checkbox  
                      v-model="row.item.public"
                      @change="updateStatus(row.item)"
                  >  
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(sold)="row"> 
                  <b-form-checkbox  
                      v-model="row.item.sold"
                      @change="updateStatusSold(row.item)"
                  >  
                  </b-form-checkbox>
                </template>
          </b-table>  
      </div>
      <b-container>
        <b-row class="justify-content-end">
          <b-col sm="6">
            <b-pagination
              v-model="currentPage2"
              :total-rows="quotes.length"
              :per-page="perPage2"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </div> 
    <b-modal v-model="modalDelete" hide-footer>
            <template v-slot:modal-title>
                ¿Está seguro que desea borrar la cotización?
            </template>
            <div class="d-block text-center">
            <h3>Esta acción es irreversible.</h3>
            </div>
            <div style="text-align:center;">
                <b-button class="m-3" @click="modalDelete = !modalDelete" variant="danger">Cerrar</b-button>
                <b-button class="m-3" @click="confirmDelete()" variant="success">Borrar</b-button>
            </div>
        </b-modal>
  </b-container>
</template>
 
<script> 
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import axios from 'axios'
  export default {
    name: 'Services',
    props: ['cliente'],
    components: {
      Loading
    },
    data() {
      return {
        modalDelete: false,
        tmpid: null,
        isLoading: false,
        items: [ 
        ],
        quotes:[],
        fields: [ 
            { key: 'snumber', label: 'No. Servicio' }, 
            { key: 'address', label: 'Dirección' }, 
            { key: 'city.name', label: 'Ciudad' },  
            { key: 'contact', label: 'Contacto' },
            { key: 'created', label: 'Fecha agregado' },
            { key: "actions", label: "" }
        ],
        fields2: [ 
           { key: 'data.servicio.snumber', label: 'No. Servicio' }, 
            { key: 'data.cliente.firstname', label: 'Cliente' }, 
            { key: 'data.porcentaje_cobertura', label: 'Porcentaje' }, 
            { key: 'data.servicio.city.name', label: 'Ciudad' },
            { key: 'createdAt', label: 'Fecha agregado' },
            { key: 'public', label: 'Público' },
             { key: 'sold', label: 'Vendido' },
            { key: "actions", label: "" }
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 5,
        totalRows2: 1,
        currentPage2: 1,
        perPage2: 5
      }
    },
    computed: { 
    },
    mounted() {  
      this.totalRows = this.items.length 
      this.listar();
      this.getQuotes();  
    }, 
    methods: {
      listar(){
        let me=this;  
        axios.get('customer/'+this.$route.params.id).then(function (response){  
            if(response.data.servicesNumbers){
                 me.totalRows = response.data.servicesNumbers.length;
            }
            me.items=response.data;  
        }).catch(function(error){
        });
      },
      getQuotes(){
        let me=this;  
        axios.get('quotes/'+this.$route.params.id).then(function (response){ 
          me.totalRows2 = response.data.length;
            me.quotes=response.data;  
        }).catch(function(error){
        });
      },
       view(iduser) { 
            this.$router.push({ name: "cotizacion_id",  params: { id: iduser } });
        },
        openPDF(id) { 
            window.open(
                "https://services.createchenergias.mx/pdf/?id=" +JSON.parse(JSON.stringify(id))+"&token="+this.token(),
                "_blank"
            );
        },
        token() {
            return this.$store.state.token
        },
        modalDeletef(id){
            this.tmpid = id;
            this.modalDelete = true;
        },
        confirmDelete(){
            let me=this; 
            axios.delete('quotation/'+this.tmpid)
            .then(function (response){  
                me.modalDelete = false;
                me.listar();
            })
            .catch(function(error){
            });
        },
        updateStatus(item){
          let me=this; 
            axios.put('quotation/'+item._id+ "/"+ !item.public)
            .then(function (response){   
                me.listar();
            })
            .catch(function(error){
            });
        },
        showMsgBoxOne(item) {
        this.boxOne = ''
        this.$bvModal.msgBoxConfirm('Estas seguro que deseas marcar como vendido este proyecto?')
          .then(value => {
            if(value == true){
              this.updateStatusSold(item);
            } 
          })
          .catch(err => {
            // An error occurred
          })
      },
        updateStatusSold(item){ 
          let me=this; 
            axios.put('quotationSold/'+item._id+ "/"+ !item.sold)
            .then(function (response){   
                me.listar();
            })
            .catch(function(error){
            });
        }
    }
  }
</script>
<style>
  ul.client_details,
  ul.client_details li {
    list-style: none;
    text-align: left;
    padding: 0px;
    margin: 0px;
  }
  table.table { 
    font-family: 'Karla', sans-serif;  
    color: #444 !important;
  }
  table.table thead {
    background: #F4F4F4; 
    border: 0px transparent; 
    font-family: 'Karla', sans-serif; 
    font-weight: 700 !important; 
    color: #444 !important;
  }
  h4 {
    font-family: 'Karla', sans-serif; 
    font-weight: 700 !important; 
    color: #000 !important;
    font-size: 22px !important; 
  }
  footer {
    background:#fff !important;
  }
</style>